<template>

    <!-- Page Sidebar Ends-->
    <div class="page-body">
        <PageTitle  title="Categories" />
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-header">
                            <button class="btn btn-secondary" type="button" data-bs-toggle="modal"
                                data-original-title="test" data-bs-target="#categoryAdd">Add Category</button>
                        </div>
                        <div class="card-body badge-spacing">
                            <div class="table-responsive custom-scrollbar">
                                <table class="table display" id="basic-1">
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Status</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr  v-for="(item ,index)  in categories" :key="item.id" >
                                            <td>{{item.categoryname}}</td>
                                            <td>{{(item.categorystatus==1)?'Active':'De-Active'}}</td>
                                            <td>
                                                <ul class="action">
                                                    <li class="edit" @click="edit_category(item.id)"><i class="icon-pencil-alt"></i></li>
                                                    <li class="delete" @click="remove_category(item.id)"><i class="icon-trash"></i></li>
                                                </ul>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- footer   start-->

    <ModalsPart v-if="!['login'].includes($route.name)" @getCategoryData="updateData"/>
</template>

<script>
// @ is an alias to /src 
import PageTitle from '@/components/PageTitle.vue';
import ModalsPart from '@/components/Modals.vue';
import axios from 'axios';
const config = {
            headers: {
               "Content-Type": "application/x-www-form-urlencoded"
            },
            responseType: 'json'
         };
export default {
    name: 'Categories', 
    components: {
        PageTitle, ModalsPart
    }, mounted() {
        this.getBasics();

    }, data() {
        return {
            categories: []
        }
    },
    methods: {
        updateData(value) {
            this.categories = value;
        },
        getBasics() {
            var self = this;
            axios.post('getCategories', config).then(function (response) {
                self.categories = response.data.categories; 
                window.scrollTo(0, 0);
            });
        },
        remove_category(id) {
            var self = this;
            axios.post('removeCategory', {category_id:id}).then(function (response) {
                self.categories = response.data.categories; 
                window.scrollTo(0, 0);
            });
        }
       
    }
}
</script>
